module.exports = __webpack_public_path__ + "static/media/fruits_23.a93ed7b9.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_23.csv
// module id = 688
// module chunks = 0